import { get, set, isEmpty } from 'lodash'
import mutationsHelpers from '@/store/modules/rev/mutationsHelpers.js'

export default function setRev(state, rev) {
  const newRev = {
    ...rev,
    predictedFinancialImpactInUSD: rev?.predictedFinancialImpactInUSD ?? null,
    team: deserializeTeam(rev),
    rootCauses: getRootCauses(rev),
    type: 'problemSolving',
  }

  const problemMedia = deserializeProblemMedia(rev)
  if (!isEmpty(problemMedia))
    set(newRev, 'problemAnalysis.problemMedia', problemMedia)

  const countermeasuresMedia = deserializeCountermeasuresMedia(rev)
  if (!isEmpty(countermeasuresMedia))
    set(newRev, 'problemAnalysis.countermeasuresMedia', countermeasuresMedia)

  const rootCauseMedia = deserializeRootCauseMedia(rev)
  if (!isEmpty(rootCauseMedia))
    set(newRev, 'problemAnalysis.rootCauseMedia', rootCauseMedia)

  state.rev = newRev
}

function deserializeTeam(rev) {
  return {
    owner: rev.team.owner ? mutationsHelpers.formatOwner(rev.team.owner) : {},
    coach: rev.team.coach ? mutationsHelpers.formatCoach(rev.team.coach) : {},
    collaborators: rev.team.collaborators
      ? rev.team.collaborators.map(mutationsHelpers.formatUser)
      : [],
  }
}

function deserializeProblemMedia(rev) {
  const problemMedia = get(rev, 'problemAnalysis.problemMedia') || []
  return problemMedia
}

function deserializeCountermeasuresMedia(rev) {
  const countermeasuresMedia =
    get(rev, 'problemAnalysis.countermeasuresMedia') || []
  return countermeasuresMedia
}

function deserializeRootCauseMedia(rev) {
  const rootCauseMedia = get(rev, 'problemAnalysis.rootCauseMedia') || []
  return rootCauseMedia
}

function getRootCauses(rev) {
  const rootCauses = rev?.rootCauses ?? []
  return rootCauses.map(rootCause => {
    const correctiveActionAssignees = rootCause?.correctiveActionAssignees ?? []
    return {
      ...rootCause,
      correctiveActionMedia: deserializeCorrectiveActionMedia(rootCause),
      correctiveActionAssignees: correctiveActionAssignees.map(
        mutationsHelpers.formatUser
      ),
    }
  })
}

function deserializeCorrectiveActionMedia(rootCause) {
  const correctiveActionMedia = get(rootCause, 'correctiveActionMedia') || []
  return correctiveActionMedia
}
